import { Divider, Grid } from '@material-ui/core'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { format } from 'date-fns'
import { releaseNotesStyles } from './styles'
import CircularProgress from '@material-ui/core/CircularProgress';


const ReleaseNotes = () => {
    const [releaseInformation, setReleaseInfo] = useState([])
    const [loadingNotes, setLoading] = useState(true)
    const elementRefs = useRef([]);


    useEffect(() => {
        const fetchReleaseInfo = async () => {
            try {
                const response = await fetch(`${process.env.PUBLIC_URL}/release_information.json`);
                const data = await response.json();
                console.log('RESPONSE,', data)
                setReleaseInfo(data);
                setLoading(false)
            } catch (error) {
                console.error('Error fetching release information:', error);
            }
        };

        fetchReleaseInfo();
    }, []);


    const scrollToElement = (index) => {
        if (elementRefs.current?.[index]) {
            elementRefs.current?.[index].scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
    };

    if (loadingNotes) return <div style={releaseNotesStyles.loader}> <CircularProgress style={{ color: 'rgb(41, 45, 57)' }} /></div>

    return (
        <Grid style={releaseNotesStyles.container} container alignItems='center'>
            <Grid style={releaseNotesStyles.tagsBar} item xs={1}>
                {releaseInformation?.map((info, index) => (
                    <Fragment key={info?.tag_name + index}>
                        <div
                            onClick={() => scrollToElement(index)}
                            style={{ marginBottom: 10, color: '#007bff', cursor: 'pointer' }}
                        >
                            {info?.tag_name}
                        </div>
                    </Fragment>
                ))}
            </Grid>
            <Divider orientation='vertical' style={{ margin: '0 1rem' }} />
            <Grid style={releaseNotesStyles.rightSection} item xs={10}>
                {releaseInformation?.map((info, index) => (
                    <div ref={(el) => (elementRefs.current[index] = el)} key={info.commit?.short_id + info.description} style={{ marginBottom: 10 }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={releaseNotesStyles.containerStyle}>
                                {format(new Date(info?.created_at), 'dd.M.yy')}
                            </div>
                            <div style={{ color: 'rgb(41, 45, 57)' }}>{info?.name}</div>
                        </div>
                        <div style={releaseNotesStyles.desc}>
                            {info.description}
                            <span style={releaseNotesStyles.commitInfo}>{info.commit?.short_id}</span>
                        </div>
                    </div>
                ))}
            </Grid>
        </Grid>
    )
}

export default ReleaseNotes
